export const StorageKey = {
  VISIT_FEATURE_URL_PATHNAME_KEY: 'visitFeatureUrlPathname',
  COACH_MARK_FIRST_LOGIN: 'welcomeModalAlreadyShown',
  SHOW_AP_INVOICE_LIST_ONBOARDING: 'showAPInvoiceListOnboarding',
  SHOW_AP_TRANSACTION_LIST_ONBOARDING: 'showAPTransactionListOnboarding',
  SHOW_AP_CREATE_INVOICE_STEP_ONE_ONBOARDING:
    'showAPCreateInvoiceStepOneOnboarding',
  SHOW_AP_CREATE_INVOICE_STEP_TWO_ONBOARDING:
    'showAPCreateInvoiceStepTwoOnboarding',
  SHOW_AR_INVOICE_LIST_ONBOARDING: 'showARInvoiceListOnboarding',
  SHOW_AR_CREATE_INVOICE_ONBOARDING: 'showARCreateInvoiceOnboarding',
  SHOW_AR_INVOICE_CUSTOMIZATION_ONBOARDING:
    'showARInvoiceCustomizationOnboarding',
  SHOW_AR_INVOICE_CONFIGS_ONBOARDING: 'showARInvoiceConfigsOnboarding',
  SHOW_VCC_PROMOTION_ADS: 'showVCCPromotionAds',
  SHOW_VCC_PROMOTION_ADS_CARD_HOLDER: 'showVCCPromotionAdsCardHolder',
  SHOW_VCC_DASHBOARD_ONBOARDING: 'showVccDashboardOnboarding',
  SHOW_VCC_CREATE_CARD_ONBOARDING: 'showVccCreateCardOnboarding',
  AUTH: 'auth',
};
